<template>
  <!-- 以旧换新 -->
  <div class="home-navigation-transparent">
    <div class="title">学而思20年感恩季</div>
    <div class="tips">老学员购学而思学习机最高立减600元</div>
    <div class="jump" @click="jumpToNew">
      <span>了解详情</span>
      <span class="icon"></span>
    </div>
  </div>
  <BannerVideo />
  <SwiperCard />
  <CardList />
</template>
<script setup>
import BannerVideo from "../components/BannerVideo.vue";
import SwiperCard from "../components/SwiperCard.vue";
import CardList from "../components/CardList.vue";

console.log("HomeView");
const jumpToNew = () => {
  window.open("https://xpad.xueersi.com/siyouReduce?source_id=226");
};
</script>
<style lang="less" scope>
.home-navigation-transparent {
  position: fixed;
  top: 78px;
  width: 100%;
  height: 100px;
  z-index: 500;
  background: rgba(0, 108, 239, 0.8);
  // border-top: 1px solid #d8d8d8;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: PingFang SC;
  .title {
    color: #fff;
    font-weight: 600;
    font-size: 24px;
    margin-right: 8px;
  }
  .tips {
    font-size: 24px;
    color: #fff;
    margin-right: 10px;
    font-weight: normal;
  }
  .jump {
    color: #b8d8ff;
    font-size: 24px;
    display: flex;
    align-items: center;
    cursor: pointer;
    .icon {
      width: 24px;
      height: 24px;
      display: block;
      background-image: url("../assets/next-icon.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      margin-right: 8px;
    }
  }
}
</style>
